module.exports = __webpack_public_path__ + "static/media/cabmate.0f96b53f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabmate.JPG
// module id = 70
// module chunks = 0